<template>
  <div class="p-case-list" :class="[{ 'is-web': isWeb }]" ref="scrollContainer">
    <div class="p-block">
      <div class="p-block-title">
        <p class="main">{{ baseData.title }}</p>
      </div>
    </div>
    <div class="navigation">
      <KdTab :navigationTab="tabList" @selected="selectedFn"></KdTab>
    </div>
    <div class="waterfall" :class="[{ 'is-loading': isLoading }]">
      <ul ref="waterfallContainer" v-if="waterfallList.length > 0">
        <li
          v-for="(item, index) in waterfallList"
          :index="index"
          :key="item.id"
          @click="toCase(item)"
        >
          <p>
            <img :src="item.image" />
          </p>
          <p>{{ item.title }}</p>
          <p>{{ item.subtitle }}</p>
        </li>
      </ul>
      <ul class="loading" v-if="hasMore">
        <li
          v-for="(item, index) in waterfallLoadingLength"
          :index="index"
          :key="index"
        >
          <kd-skeleton />
        </li>
      </ul>

      <ul class="empty" v-if="!hasMore && waterfallList.length === 0">
        <p>暂无数据</p>
      </ul>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash';
import { customData } from '../config';
import KdTab from '@/components/KdTab/index.vue';
import { officialTextQuery } from '@/common/request';
import { getFromPage, getPageName } from '@/common/utils/index';
import { isIOS } from '@/common/utils';
import infoCollect from '@/common/infoCollect';
import { isEnvMobile } from '@/common/utils';

export default {
  name: 'list-component',
  components: { KdTab },
  data() {
    return {
      isWeb: false,
      customRequestData: null,
      baseData: customData,
      navigationSelected: 0,
      tabList: ['基础教育', '高等教育'],
      waterfallList: [], // 存储数据的数组
      pageNum: 1, // 页码
      pageSize: 3, // 页数
      waterfallLoadingLength: 0,
      isLoading: false, // 是否正在加载中
      hasMore: true, // 是否有更多数据可以加载
    };
  },
  props: {
    needLoadMore: {
      type: Boolean,
      default: true,
    },
    listParamsPos: {
      type: Array,
      default: [],
    },
  },
  methods: {
    toCase(item) {
      infoCollect.dwCollectData(
        'button_click',
        item.nameEn,
        this.isWeb ? (isIOS() ? 'ios' : 'android') : 'PC',
        { page_name: getPageName(), from_item: getFromPage() },
      );
      window.open(item.actionContent, '_blank');
    },
    selectedFn(index) {
      this.navigationSelected = index;
      this.waterfallList = [];
      this.pageNum = 1;
      this.pageSize = this.needLoadMore ? 9 : 3;
      this.waterfallLoadingLength = 0;
      this.isLoading = false;
      this.hasMore = true;
      setTimeout(() => {
        this.loadMore();
      }, 100);
    },

    // 加载更多数据的函数
    async loadMore() {
      if (!this.hasMore) {
        return true;
      }
      this.isLoading = true; // 设置加载状态为true
      try {
        this.waterfallLoadingLength += this.isWeb ? 1 : 3;
        const waterfallListAppend = await officialTextQuery({
          pos: this.listParamsPos[this.navigationSelected],
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        });
        if (waterfallListAppend?.records.length === 0) {
          this.hasMore = false;
          this.isLoading = false;
          return;
        }
        const data = this.needLoadMore
          ? waterfallListAppend?.records
          : waterfallListAppend?.records.slice(0, 3);
        if (
          data.length > 0 &&
          waterfallListAppend?.records.length <= this.pageSize
        ) {
          // 将新数据追加到现有数据列表中
          const _list = Object.assign(this.waterfallList);
          this.waterfallList = _list.concat(data);

          if (waterfallListAppend?.records.length < this.pageSize) {
            this.hasMore = false; // 没有更多数据了，更新状态为false
          } else {
            if (this.needLoadMore) {
              this.pageNum++; // 页码自增
            } else {
              this.hasMore = this.needLoadMore;
            }
          }
        } else {
          this.hasMore = false; // 没有更多数据了，更新状态为false
        }
        this.isLoading = false;
      } catch (error) {
        this.hasMore = false;
        this.isLoading = false;
      }
    },
    handleWindowScroll: debounce(function () {
      if (this.needLoadMore && this.hasMore) {
        const _container = this.$refs.waterfallContainer;
        const _window = window.document.documentElement;
        if (_container.scrollHeight - _window.scrollTop < 200) {
          this.loadMore(); // 到达底部时调用加载更多函数
        }
      }
    }, 200),
  },
  mounted() {
    this.isWeb = isEnvMobile();
    this.pageSize = this.needLoadMore ? 9 : 3;
    this.loadMore();
  },
  beforeMount() {
    window.addEventListener('scroll', this.handleWindowScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleWindowScroll);
  },
};
</script>

<style lang="scss" scoped>
.p-case-list {
  max-width: 1200px;
  margin: 0px auto;
  &.is-web {
    min-height: px2rem(452);
    .waterfall {
      position: relative;
      margin-bottom: 0;
      min-height: px2rem(452 + 80);
      &.is-loading {
        padding-bottom: px2rem(0);
      }
      .loading {
        position: absolute;
        bottom: px2rem(0);
        z-index: -1;
        left: 50%;
        transform: translate(-50%, 0);
        width: 100%;
      }

      ul {
        margin: 0 auto;
        width: 100% !important;
        li {
          width: 100%;
          display: inline-block;
          height: px2rem(452);
          border-width: 1px;
          border-radius: px2rem(20);
          padding: px2rem(48);
          border: 1px solid var(--kd-color-line-regular, rgba(13, 13, 13, 0.12));
          box-shadow: 0px px2rem(8) px2rem(20) 0px rgba(13, 13, 13, 0.03);
          margin-top: px2rem(80);
          cursor: pointer;
          background: #fff;
          margin-right: 0 !important;

          p:nth-child(1) {
            img {
              width: auto;
              height: px2rem(78);
            }
          }
          p:nth-child(2) {
            margin-top: px2rem(32);
            font-weight: 600;
            font-size: px2rem(32);
            line-height: px2rem(48);
            height: px2rem(96);
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            color: var(--kd-color-text-primary, rgb(13 13 13 / 90%));
          }
          p:nth-child(3) {
            margin-top: px2rem(100);
            font-weight: 400;
            font-size: px2rem(28);
            line-height: px2rem(44);
            color: var(--kd-color-text-secondary, rgba(13, 13, 13, 0.66));
          }
        }
      }
      .empty {
        height: px2rem(400);
        font-size: px2rem(28);
      }
    }
  }
  .navigation {
    text-align: center;
    .kdv-navigation {
      flex-direction: column;
      .kdv-navigation-item {
        :deep(.kdv-navigation-item--text) {
          margin-right: 14px;
        }
        :deep(.kdv-navigation-item__txt) {
          width: 88px;
          height: 33px;
          line-height: 31px !important;
          font-size: var(--kd-font-size-base, 14px);
          color: var(--kd-color-text-primary, rgb(13 13 13 / 90%));
          border: 1px solid var(--kd-color-line-light, rgb(13 13 13 / 6%));
          font-weight: 600;
          text-align: center;
          background: #fff;
          border-radius: 999px;
        }
        &.is-active {
          :deep(.kdv-navigation-item__txt) {
            background: rgba(0, 0, 0, 1);
            color: #fff;
          }
        }
      }
    }
  }
  .waterfall {
    margin-bottom: 72px;
    position: relative;
    min-height: 312px;
    &.is-loading {
      padding-bottom: 312px;
    }
    .loading {
      position: absolute;
      bottom: 0;
      z-index: -1;
      left: 50%;
      transform: translate(-50%, 0);
      width: 100%;
      li {
        box-shadow: none;
      }
    }
    ul {
      margin: 0 auto;
      li {
        width: 384px;
        display: inline-block;
        height: 272px;
        border-width: 1px;
        border-radius: 10px;
        padding: 32px;
        margin-right: 24px;
        border: 1px solid var(--kd-color-line-regular, rgba(13, 13, 13, 0.12));
        box-shadow: 0px 4px 20px 0px rgba(13, 13, 13, 0.03);
        margin-top: 40px;
        cursor: pointer;
        background: #fff;

        &:nth-child(3n) {
          margin-right: 0;
        }
        p:nth-child(1) {
          img {
            width: auto;
            height: 40px;
          }
        }
        p:nth-child(2) {
          margin-top: 16px;
          font-weight: 600;
          font-size: 16px;
          line-height: 24px;
          height: 48px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          color: var(--kd-color-text-primary, rgb(13 13 13 / 90%));
        }
        p:nth-child(3) {
          margin-top: 80px;
          font-weight: 400;
          font-size: 14px;
          line-height: 22px;
          color: var(--kd-color-text-secondary, rgba(13, 13, 13, 0.66));
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
        }
      }
    }
    .empty {
      width: 100%;
      height: 300px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
    }
  }

  @include responsiveV2($width-m) {
    .waterfall {
      &.is-loading {
        padding-bottom: 624px;
      }
      ul {
        width: 792px !important;
        li {
          &:nth-child(2n) {
            margin-right: 0 !important;
          }
          &:nth-child(3n) {
            margin-right: 24px;
          }
        }
      }
    }
  }
}
</style>
